import * as ApiClient from '@/libs/ApiClient';
import type { AxiosResponse } from 'axios';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * 取消上傳中的案件回應
 */
export interface ICancelUploadingResponse {
    /** 回應狀態 */
    status: boolean;
    /** 錯誤代碼 */
    code: number;
    /** 例外訊息 */
    exception: string | null;
    /** 訊息 */
    message: string | null;
}

/**
 * DocumentCase - 取消上傳中的案件 API
 *
 * @description 取消當前上傳中的補件案件，所有已上傳的檔案將被刪除
 * @returns Promise<ICancelUploadingResponse>
 */
export async function CancelUploading(): Promise<ICancelUploadingResponse> {
    const url = RouteUrlList.API_CancelUploading.path;
    const config = {
        params: {
            showOverlay: ApiClient.paramTypeEnum.true,
            getServiceAlert: ApiClient.paramTypeEnum.true
        }
    };

    return await ApiClient.post(url, {}, config).then((res: AxiosResponse<ICancelUploadingResponse>) => {
        return res.data;
    });
}

export default CancelUploading;
